import { Injectable } from '@angular/core';

// Custom
import { Dictionary } from 'src/app/core/helper/util';
import { HttpClient } from '@angular/common/http';
import { HttpService } from 'src/app/core/data/service/http.service';


export class HelpText {

  helpTextId: number;
  appKey: string;
  pageKey: string;
  htmlContent: string;
  deleted: boolean;

  public constructor(entity?: Partial<HelpText>) {
    Object.assign(this, entity);
  }
}

@Injectable({
  providedIn: 'root'
})
export class HelpTextService extends HttpService {

  private helpDic: Dictionary<string>;

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = this.apiURL + '/helptext';
  }

  async fetchHelpText(pageKey: string) {
    try {
      // refresh if dictionary hasn't been created or key isn't found
      if (this.helpDic == null || this.helpDic[pageKey] == null) {
        const response = (await super.fetch(`${this.endpoint}/`) as HelpText[]).map(m => new HelpText(m));
        this.helpDic = {};
        response.forEach(h => {
          this.helpDic[h.pageKey] = h.htmlContent;
        });
      }
      return this.helpDic[pageKey];
    } catch (error) {
      console.error('Error fetching help text. Error: ', error);
      throw error;
    }
  }

  protected isUpdate(entity: any) {
    return (entity.helpTextId != null);
  }

  protected getUpdateUrl(entity: any) {
    return `${this.endpoint}/${entity.helpTextId}`;
  }
}
